import { render, staticRenderFns } from "./TxMap.vue?vue&type=template&id=8fdcb79e&scoped=true"
import script from "./TxMap.vue?vue&type=script&lang=js"
export * from "./TxMap.vue?vue&type=script&lang=js"
import style0 from "./TxMap.vue?vue&type=style&index=0&id=8fdcb79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdcb79e",
  null
  
)

export default component.exports